module.exports = require('./dist/uploadcare.tab-effects.react.lang.en')
